import request from '@/utils/request'

export function getSupplierDepartmentPermissions() {
  return request({
    url: '/api/mdm-service/company/supplierDepartmentPermissions',
    method: 'get'
  })
}
